import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-loader app-loader"
}
const _hoisted_2 = { class: "app-shell__main" }
const _hoisted_3 = { class: "app-shell__mobilebar" }

import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'
import { MetaService } from "@/model/MetaService"
import AuthStore from "@/store/AuthStore"
import { JobsUrl } from '@/model/api/urls'
import { CommonApi } from '@/model/api/CommonApi'
import { JobsDashboardResp } from '@/model/api/JobsApi'
import AppSidebar from '@/layout/AppSidebar.vue'
import AtlasIcon from '@/component/ui/AtlasIcon.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'DefaultLayout',
  setup(__props) {

const route = useRoute()
const showLoader = ref(true)
const navOpen = ref(false)
// Routes with meta.navRail get the icon rail; the mobile drawer always shows the full sidebar.
const railMode = computed(() => !!route.meta.navRail && !navOpen.value)
const runningJobs = ref(0)
let jobsTimer: ReturnType<typeof setInterval> | null = null

// Feeds the "N running" count next to Jobs in the sidebar. Called without
// CommonApi.catchHandler so a failed poll stays silent instead of alerting.
async function pollRunningJobs() {
  try {
    const resp = await axios.get<JobsDashboardResp>(JobsUrl, CommonApi.requestConfig())
    runningJobs.value = Object.keys(resp.data.runningJobs ?? {}).length
  } catch {
    runningJobs.value = 0
  }
}

onMounted(async () => {
  showLoader.value = AuthStore.module.isAuthorized && !MetaService.isMetaLoaded

  if (showLoader.value) {
    await MetaService.updateMeta()
    showLoader.value = !MetaService.isMetaLoaded
  }

  if (AuthStore.module.canSeeJobs) {
    pollRunningJobs()
    jobsTimer = setInterval(pollRunningJobs, 30_000)
  }
})

onUnmounted(() => {
  if (jobsTimer) clearInterval(jobsTimer)
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (showLoader.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[3] || (_cache[3] = [
        _createElementVNode("span", { class: "spinner" }, null, -1),
        _createElementVNode("span", null, "Loading…", -1)
      ]))]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["app-shell", { 'app-shell--nav-open': navOpen.value }])
      }, [
        _createVNode(AppSidebar, {
          class: "app-shell__nav",
          runningJobs: runningJobs.value,
          collapsed: railMode.value,
          onNavigate: _cache[0] || (_cache[0] = ($event: any) => (navOpen.value = false))
        }, null, 8, ["runningJobs", "collapsed"]),
        _createElementVNode("div", {
          class: "app-shell__scrim",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (navOpen.value = false))
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "icon-btn",
              type: "button",
              "aria-label": "Open navigation",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (navOpen.value = true))
            }, [
              _createVNode(AtlasIcon, { name: "menu" })
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "app-shell__mobile-title" }, "Marketing", -1))
          ]),
          _createVNode(_component_router_view)
        ])
      ], 2))
}
}

})